import type { ChatPreset } from "@/types";

/**
 * 为企业预设提供类型安全的声明入口。
 * 使用函数而非可变的全局注册器，避免 SSR/多实例之间共享注册状态。
 */
export const defineChatPreset = <TPreset extends ChatPreset>(
  preset: TPreset,
): TPreset => preset;

const mergeChatPreset = (
  base: ChatPreset,
  override: ChatPreset,
): ChatPreset => {
  const overrideTags = new Set(
    (override.markdownExtensions || []).map((item) =>
      item.tagName.toLowerCase(),
    ),
  );

  return {
    ...base,
    ...override,
    strategies: {
      ...base.strategies,
      ...override.strategies,
    },
    markdownExtensions: [
      ...(base.markdownExtensions || []).filter(
        (item) => !overrideTags.has(item.tagName.toLowerCase()),
      ),
      ...(override.markdownExtensions || []),
    ],
    createUploadRequest: Object.prototype.hasOwnProperty.call(
      override,
      "createUploadRequest",
    )
      ? override.createUploadRequest
      : base.createUploadRequest,
  };
};

/**
 * 组合基础预设、可复用能力包和企业差异。后传入的预设优先，策略按字段浅合并，
 * Markdown 扩展按 tagName 去重并由后者覆盖。
 */
export const composeChatPresets = (
  base: ChatPreset,
  ...overrides: ChatPreset[]
): ChatPreset =>
  overrides.reduce(mergeChatPreset, base);
